/** Permission catalog (mirrors halo_contracts.rbac.CATALOG_PERMISSIONS). */

export function permissionKey(resource, action) {
  return `${resource}:${action}`;
}

export const CATALOG_PERMISSIONS = [
  ["dashboard", "read"],
  ["trigger-workflow", "read"],
  ["trigger-workflow", "trigger"],
  ["tickets", "read"],
  ["tickets", "create"],
  ["tickets", "update"],
  ["agent-studio", "read"],
  ["agent-studio", "write"],
  ["vibe-studio", "read"],
  ["vibe-studio", "write"],
  ["discovery", "read"],
  ["deployment", "read"],
  ["deployment", "write"],
  ["errors", "read"],
  ["errors", "write"],
  ["approvals", "read"],
  ["approvals", "write"],
  ["ffid", "update"],
  ["analytics", "read"],
  ["business-value", "read"],
  ["business-value", "write"],
  ["reports", "read"],
  ["documentation", "read"],
  ["settings.general", "read"],
  ["settings.general", "write"],
  ["settings.notifications", "read"],
  ["settings.notifications", "write"],
  ["settings.sap-landscape", "read"],
  ["settings.sap-landscape", "write"],
  ["settings.mcp-servers", "read"],
  ["settings.mcp-servers", "write"],
  ["settings.user-management", "read"],
  ["settings.group-management", "read"],
  ["settings.group-management", "write"],
  ["admin.users", "read"],
  ["admin.users", "create"],
  ["admin.users", "update"],
  ["admin.users", "delete"],
  ["admin.groups", "read"],
  ["admin.groups", "create"],
  ["admin.groups", "update"],
  ["admin.groups", "delete"],
];

export const ALL_PERMISSION_KEYS = CATALOG_PERMISSIONS.map(([r, a]) =>
  permissionKey(r, a),
);

/** Group permissions by resource for matrix UI. */
export function permissionsByResource() {
  const map = new Map();
  for (const [resource, action] of CATALOG_PERMISSIONS) {
    if (!map.has(resource)) map.set(resource, []);
    map.get(resource).push(action);
  }
  return map;
}
